import React from "react";
import moment from "moment";
import styled, { withTheme } from "styled-components";
import EntityList from "../../EntityList/EntityList";
import { CONTRACT_STATUS, CONTROLS_POSITION } from "../../../Common/constants";
import { defineMessages, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import axios from "http/customAxios";
import { BASE_URL } from "../../../request";

const messages = defineMessages({
  grossTotal: {
    id: "crm.propertiesList.grossTotal",
    description: "Total brute",
    defaultMessage: "Total brute",
  },
});

const StyledClientsCellContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  font-size: 14px;
`;

const StyledClientsCell = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const StyledNumContractsCell = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0 0;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
`;

function customEntityToListValuesMapper(dictionaries) {
  return ({ entities }) =>
    entities.map(originalEntity => {
      const entity = { ...originalEntity };
      if (originalEntity.status === CONTRACT_STATUS.CANCELLED) {
        entity.status = "baja";
      }
      let partner = undefined;
      if (originalEntity.partner) {
        const entry = Object.entries(dictionaries.partners).find(
          ([k, v]) => v === originalEntity.partner
        );
        if (entry) {
          partner = entry[0];
        }
      }
      entity.partner = partner;
      entity.frontEndActivated = originalEntity.frontEndActivated ? "OK" : "KO";
      entity.backOfficeActivated = originalEntity.backOfficeActivated ? "OK" : "KO";
      entity.created = moment(originalEntity.created).format("YYYY-MM-DD");
      entity.updated = moment(originalEntity.updated).format("YYYY-MM-DD");
      const clients = originalEntity.clients && originalEntity.clients.map(client => client.id);
      entity.clients = clients && clients.join(", ");
      return entity;
    });
}

class PropertiesList extends React.Component {
  state = {};

  componentDidMount() {
    // TODO: replace with httpclient
    axios.get(`${BASE_URL}/api/crm/properties/dictionaries`).then(response => {
      if (response.status === 200 && response.data) {
        this.setState({ dictionaries: response.data });
      }
    });
  }

  componentWillUnmount() {}

  clientsCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const clients = entity && entity[fieldName] && entity[fieldName].split(", ");
    if (!clients) {
      return;
    }
    return (
      <StyledClientsCellContainer>
        {clients.map((clientId, idx) => (
          <>
            <Link
              style={{ color: this.props.theme.regularTextColor }}
              target="_blank"
              to={`/crm/clients/${clientId}`}>
              <StyledClientsCell>{clientId}</StyledClientsCell>
            </Link>
            {idx + 1 < clients.length && <span>,&nbsp;</span>}
          </>
        ))}
      </StyledClientsCellContainer>
    );
  };

  numContractsCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return (
      <Link
        style={{ color: this.props.theme.regularTextColor }}
        target="_blank"
        to={`/crm/contracts?property=${entity.ticker}`}>
        <StyledNumContractsCell>{value}</StyledNumContractsCell>
      </Link>
    );
  };

  additionalTotalRecords = ({ totalRecords }) => (
    <div>
      <FormattedMessage {...messages.grossTotal} />
      {": "}
      {totalRecords && (totalRecords * 1.8).toFixed(0)}
    </div>
  );

  render() {
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowCreate,
      allowDelete,
      allowClone,
      allowExport,
      exportFileName,
      reorder,
      filterFields,
      showTotalRecords,
    } = this.props.config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    renderers.numContracts = this.numContractsCell;
    renderers.clients = this.clientsCell;
    const { dictionaries } = this.state;

    return (
      <EntityList
        filterFields={filterFields}
        loading={loading || !dictionaries}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        customEntityToListValuesMapper={customEntityToListValuesMapper(dictionaries)}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        currentLocale={this.props.config.locale}
        success={success}
        sorting={sorting}
        allowCreate={allowCreate}
        allowDelete={allowDelete}
        allowClone={allowClone}
        allowExport={allowExport}
        exportFileName={exportFileName}
        reorder={reorder}
        maxColumnWidth={300}
        horizontalScroll
        showTotalRecords={showTotalRecords}
        additionalTotalRecords={this.additionalTotalRecords}
        controlsPosition={CONTROLS_POSITION.TOP}
        hasFilters
      />
    );
  }
}

PropertiesList.propTypes = {};

PropertiesList.defaultProps = {};

export default withTheme(PropertiesList);
